import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap'
import { IOrganizationModel } from '../models/Organization';

interface IOrganizationList {
  organizations: Array<IOrganizationModel>
};

export const OrganizationList = observer(({ organizations }: IOrganizationList) => {
  if (organizations === void 0 || organizations === null)
    return null;

  return (
    <div>
      {
        organizations.map((org: IOrganizationModel) => {
          return (
            <div className="org-container well" key={org.id}>
              <h3 className="title">
                <Link to={`/organization/${org.id}`}>
                  <span className="org">{org.name}</span>
                  <small><Glyphicon glyph='pencil'></Glyphicon></small>
                </Link>
                <div className="pull-right">
                  {org.email.length > 0 && <small className="ml-5"><b>Email:</b> {org.email}</small>}
                  {org.apiKey.length > 0 && <small className="ml-4"><b>Api key:</b> {org.apiKey}</small>}
                </div>
              </h3>
              {org.children && org.children.length > 0 && <Glyphicon glyph='arrow-right'></Glyphicon>}
              {org.children && org.children.map((childOrg: any) => {
                return (
                  <Link to={`/organization/${childOrg.id}`} className="ml-4" key={childOrg.id}>
                    <span className="org child-org">{childOrg.name}</span>
                  </Link>
                )
              })
              }
            </div>
          )
        })
      }
    </div>
  )
});